module.exports = __webpack_public_path__ + "img/whatsup-card.fafaccb5.jpg";